module.exports = __webpack_public_path__ + "img/icon.0af8fe74.png";